<template>
  <div class="container">
    <div class="container_form">
      <el-form :inline="true" :model="formObj" label-width="90px" size="small" ref="formRefs">
        <el-form-item label="车型" prop="carModelIds">
          <el-select v-model="formObj.carModelIds" multiple filterable placeholder="请选择车型" style="width: 200px">
            <el-option
              v-for="item in allDeviceModelDrownList"
              :key="item.id"
              :label="item.modelName + ' | ' + item.brandName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="主机订单号" prop="mainOrderNo">
          <el-input type="text" v-model="formObj.mainOrderNo" placeholder="请输入主机订单号" style="width: 200px"></el-input>
        </el-form-item>

        <el-form-item label="上游订单号" prop="upstreamOrderNo">
          <el-input type="text" v-model="formObj.upstreamOrderNo" placeholder="请输入上游订单号" style="width: 200px"></el-input>
        </el-form-item>

        <el-form-item label="客户名称" prop="customerName">
          <el-input type="text" v-model="formObj.customerName" placeholder="请输入客户名称" style="width: 200px"></el-input>
        </el-form-item>

        <el-form-item label="联系方式" prop="contactInfo">
          <el-input type="text" v-model="formObj.contactInfo" placeholder="请输入联系方式" style="width: 200px"></el-input>
        </el-form-item>

        <el-form-item label="安装师傅" prop="installerIds">
          <el-select v-model="formObj.installerIds" filterable multiple placeholder="请选择安装师傅" style="width: 200px">
            <el-option
                v-for="item in allUserList"
                :key="item.id"
                :label="item.userName"
                :value="item.id"
              ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="small" @click="getTableData">查询</el-button>
          <el-button type="info" size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <div class="container_table">
        <BaseTable
          ref="tableRefs"
          :tableData="relatedOrdersData"
          :isSelection="true"
          :columns="relatedOrdersColumns"
          @selection-change="handleSelectionChange"
          :maxHeight="600"
        >
        <template #source="{row}">
          <span>{{row.source ? '导入' : '手动新建'}}</span>
        </template>
      </BaseTable>
      </div>
    </div>
  </div>
</template>

<script>
import BaseTable from "@/components/BaseTable";
import { relatedOrdersColumns } from "./columns.js";
export default {
  name: "RelatedOrders",
  components: {
    BaseTable,
  },
  props: {
    dialogFlag: {
      type: Boolean,
      default: false,
    },
    addForm: {
      type: Object,
      default: ()=>{},
    },
  },
  data() {
    return {
      relatedOrdersData: [], //关联订单
      relatedOrdersColumns: relatedOrdersColumns,
      formObj: {
        carModelIds: [], //车型ID
        mainOrderNo: "", //主机订单号
        upstreamOrderNo: "", //上游订单号
        customerName: "", //客户名称
        contactInfo: "", //联系方式
        installerIds: [], //安装师傅ID
        
      },
      allDeviceModelDrownList: [], //车型列表
      allUserList: this.$store.state.allUserList || [], //安装师傅列表
      selectData: []   //选中的数据id
    };
  },
  watch: {
    dialogFlag: {
      handler(val) {
        if (val) {
          this.queryDeviceModelDrown();
          this.getTableData();
          this.loadAllUserList();
          this.reset()
        }else{
          this.selectData = []
        }
      },
      immediate: true,
    },
  },
  methods:{
    // 加载所有用户列表
    async loadAllUserList() {
      try {
        // 调用store的action来获取最新的用户列表
        await this.$store.dispatch('setAllUserList');
        // 更新本地数据
        this.allUserList = this.$store.state.allUserList;
      } catch (error) {
        console.error('加载用户列表失败:', error);
        this.$message.error('加载用户列表失败');
      }
    },
    getTableData(){
      this.axios({
        url: "/pending-settlement-order/listBySettlementBatchName",
        method: "post",
        data: {
          page:0,
          size:0,
          queryInfoParams: {
            ...this.addForm,
            ...this.formObj,
            relatedOrderIds: this.$store.state.selectOrderIds.length > 0 ? this.$store.state.selectOrderIds.join(',') : ''
          },
        },
      }).then((res) => {
       this.relatedOrdersData = res.data.data.list;
       this.selectData = this.$store.state.selectOrderIds || []
       this.setSelectedRows()
    })
  },
    queryDeviceModelDrown() {
      this.axios({
        method: "get",
        url: "/v1/web/device-brand/select-device-model",
      }).then((res) => {
        this.allDeviceModelDrownList = res.data.data.list;
      });
    },
    reset(){
      this.$nextTick(()=>{
        this.$refs.formRefs.resetFields()
      })
    },
    handleSelectionChange(val){
      if(val.length > 0 ){
        this.selectData = val.map(item=>item.id)
      }else{
        this.selectData = []
      }
    },
    // 回显选中数据
    setSelectedRows() {
      // 清空当前选中
      this.$nextTick(()=>{
        this.$refs.tableRefs.$children[0].clearSelection();
      })
      this.selectData.forEach((id) => {
        const row = this.relatedOrdersData.find(item=> item.id === id - 0);
        this.$nextTick(() => {
          row && this.$refs.tableRefs.$children[0].toggleRowSelection(row, true)
        })
      })
    }
  }
};
</script>
<style scoped>
.selectWidth{
  width: 200px;
}
</style>